import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const faqs = [{
    q: '¿Es un libro físico?',
    a: 'No. Es una guía digital en PDF. Recibes acceso inmediato después del pago. Puedes leerla desde tu celular en 2 minutos.'
  }, {
    q: '¿Para niños de qué edad sirve?',
    a: 'El Sistema CVR está optimizado para niños de 2 a 10 años. Funciona especialmente bien con niños intensos o de temperamento fuerte.'
  }, {
    q: '¿El pago es seguro?',
    a: 'Sí. El pago es procesado por Hotmart con cifrado de nivel bancario. No almacenamos datos de tu tarjeta.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-10 md:py-20 px-5 bg-brand-cream" data-id="element-44">
      <div className="max-w-3xl mx-auto" data-id="element-45">
        <FadeIn data-id="element-46">
          <h2 className="font-serif text-2xl md:text-4xl text-brand-navy text-center mb-8" data-id="element-47">
            Preguntas frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-48">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-49">
              <div className="border border-slate-200 rounded-2xl overflow-hidden bg-white" data-id="element-50">
                <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-51">
                  <span className="font-sans font-bold text-lg text-brand-navy pr-4" data-id="element-52">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-brand-orange shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-53" />
                </button>
                <AnimatePresence data-id="element-54">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-55">
                      <div className="px-6 pb-5 text-slate-600 font-sans leading-relaxed" data-id="element-56">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}